import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '@/components/branding/Logo';
import Button from '@/components/ui/Button';

interface LandingNavProps {
  // Optional: pages other than the landing page (Privacy, Terms) mount this
  // nav without the waitlist section on the page, so "Get notified" falls
  // back to navigating home to the section instead of scrolling in place.
  onOpenWaitlist?: (source: 'nav_get_started') => void;
}

export default function LandingNav({ onOpenWaitlist }: LandingNavProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 transition-colors duration-200 ${
        scrolled
          ? 'bg-cream/80 backdrop-blur-md border-b border-border/40'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto w-full max-w-7xl px-6 md:px-8 lg:px-12 h-16 flex items-center justify-between">
        <button
          type="button"
          onClick={() => {
            if (location.pathname === '/') {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
              navigate('/');
            }
          }}
          className="cursor-pointer"
          aria-label="Citizenly home"
        >
          <Logo size="md" />
        </button>

        <Button
          size="sm"
          onClick={() => {
            if (!onOpenWaitlist) {
              navigate('/#waitlist');
              return;
            }
            if (location.pathname === '/') {
              onOpenWaitlist('nav_get_started');
            } else {
              navigate('/#waitlist');
            }
          }}
        >
          Get notified
        </Button>
      </div>
    </header>
  );
}
